import React, { useState, useRef, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Transition from '../../utils/Transition';
import { API } from 'aws-amplify';

import { useInterval } from '../../utils/Utils'
import { listNotifications } from '../../graphql/queries'
import { deleteNotification } from '../../graphql/mutations'

function Notifications({userDetails}) {

  let history = useHistory();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [user, setUser] = useState({email: 'friend', client: { adminId: ''}})
  const [notificationList, setNotificationList] = useState('');

  const trigger = useRef(null);
  const dropdown = useRef(null);
  const savedCallback = useRef()

  useEffect(() => {
    if(userDetails!=null) {
      setUser(userDetails)
      fetchNotifications(userDetails)
    }
  }, [userDetails]);

  /*useEffect(() => {
    if(userDetails!=null) {
      setUser(userDetails)
      fetchNotifications(userDetails)
    }
  }, []);*/

  useInterval(
    () => {
      fetchNotifications(null)
    },
    (60*1000)
  )

  function cleanNotificationTime(updatedOn){
      return updatedOn.split('T')[0] + ' ' + updatedOn.split('T')[1].split('.')[0]
  }

  function notificationClicked(notif){
    removeNotification(notif)
    history.push(notif.link.split('?')[0], {userDetails: userDetails, queryParams: notif.link.includes('?') ? notif.link.split('?')[1] : null})
  }


  async function fetchNotifications(userDetails){
    if(userDetails!=null && 'clientId' in userDetails && userDetails.clientId!=undefined){
      const response = await API.graphql({
        query: listNotifications,
        variables: {filter: {clientId: {eq: userDetails.clientId}}}
      })
      if (response.data.listNotifications != null) {
        var notifications = response.data.listNotifications
        if ('items' in notifications)
          setNotificationList(notifications.items.map(item =>
            <li key={item.id} className="border-b border-gray-200 last:border-0 cursor-pointer">
              {/*<Link to={{
                pathname: item.link.split('?')[0],
                state: {userDetails: userDetails, queryParams: item.link.includes('?') ? item.link.split('?')[1] : null}
              }}*/}
              <div onClick={()=>notificationClicked(item)} className="block py-2 px-4 hover:bg-gray-50 cursor-pointer">

                <div className="block text-sm mb-2 w-full">📣 <span
                  className="font-medium text-gray-800">{item.title}</span>
                  <button className="float-right bg-indigo-500 rounded-full py-1 px-2 text-white text-xs"
                          onClick={() => removeNotification(item)}>dismiss
                  </button>
                </div>
                <span className="block text-sm mb-2">{item.message}</span>
                <span className="block text-xs font-medium text-gray-400">{cleanNotificationTime(item.updatedOn)}</span>
              </div>
              {/*</Link>*/}
            </li>
          ))
      }
    }
    else if('clientId' in user && user.clientId!=null && user.clientId!=undefined){
      const response = await API.graphql({
        query: listNotifications,
        variables: {filter: {clientId: {eq: user.clientId}}}
      })
      if (response.data.listNotifications != null) {
        var notifications = response.data.listNotifications
        if ('items' in notifications)
          setNotificationList(notifications.items.map(item =>
            <li key={item.id} className="border-b border-gray-200 last:border-0 cursor-pointer">
              {/*<Link to={{
                pathname: item.link.split('?')[0],
                state: {userDetails: user, queryParams: item.link.includes('?') ? item.link.split('?')[1] : null}
              }}*/}
              <div onClick={()=>notificationClicked(item)} className="block py-2 px-4 hover:bg-gray-50 cursor-pointer">

                <div className="block text-sm mb-2 w-full">📣 <span
                  className="font-medium text-gray-800">{item.title}</span>
                  <button className="float-right bg-indigo-500 rounded-full py-1 px-2 text-white text-xs"
                          onClick={() => removeNotification(item)}>dismiss
                  </button>
                </div>
                <span className="block text-sm mb-2">{item.message}</span>
                <span className="block text-xs font-medium text-gray-400">{cleanNotificationTime(item.updatedOn)}</span>
              </div>
              {/*</Link>*/}
            </li>
          ))
      }
    }
  }
  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdown.current) return;
      if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target)) return;
      setDropdownOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  async function removeNotification(notification){
    const deletedNotification = await API.graphql({ query: deleteNotification, variables: {input: { id: notification.id }}});
    fetchNotifications()
  }

  return (
    <div className="relative inline-flex ml-3">
      <button
        ref={trigger}
        className={`w-8 h-8 flex items-center justify-center bg-gray-100 hover:bg-gray-200 transition duration-150 rounded-full ${dropdownOpen && 'bg-gray-200'}`}
        aria-haspopup="true"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        aria-expanded={dropdownOpen}
      >
        <span className="sr-only">Notifications</span>
        <svg className="w-4 h-4" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
          <path className="fill-current text-grey-400" d="M6.5 0C2.91 0 0 2.462 0 5.5c0 1.075.37 2.074 1 2.922V12l2.699-1.542A7.454 7.454 0 006.5 11c3.59 0 6.5-2.462 6.5-5.5S10.09 0 6.5 0z" />
          <path className="fill-current text-grey-300" d="M16 9.5c0-.987-.429-1.897-1.147-2.639C14.124 10.348 10.66 13 6.5 13c-.103 0-.202-.018-.305-.021C7.231 13.617 8.556 14 10 14c.449 0 .886-.04 1.307-.11L15 16v-4h-.012C15.627 11.285 16 10.425 16 9.5z" />
        </svg>
        {notificationList!=''?<div><div className="absolute top-0 right-0 w-2.5 h-2.5 bg-green-500 border-2 border-white rounded-full"></div>
          <div className="absolute top-0 right-0 w-2.5 h-2.5 bg-white border-2 border-white rounded-full animate-ping"></div></div>:''}

      </button>

      <Transition
        className="origin-top-right z-10 absolute top-full right-0 -mr-48 sm:mr-0 min-w-80 bg-white border border-gray-200 py-1.5 rounded shadow-lg overflow-hidden mt-1"
        show={dropdownOpen}
        enter="transition ease-out duration-200 transform"
        enterStart="opacity-0 -translate-y-2"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-out duration-200"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
      >
        <div
          ref={dropdown}
          onFocus={() => setDropdownOpen(true)}
          onBlur={() => setDropdownOpen(false)}
        >
          <div className="text-xs font-semibold text-gray-400 uppercase pt-1.5 pb-2 px-4">Notifications</div>
          <ul>
            {notificationList!=''?notificationList:<div className="text-sm text-gray-400 px-4">No updates</div>}
          </ul>
        </div>
      </Transition>
    </div>
  )
}

export default Notifications;